module.exports = __webpack_public_path__ + "img/lineDark.ebd285ae.svg";